import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />

    <Toaster
      position="top-right"
      reverseOrder={false}
      toastOptions={{
        className: "text-[14px]",
        style: {
          background: "#313049",
          color: "#FFFFFF",
        },
      }}
    />
  </>
);

reportWebVitals();
